import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import { FadeInTop } from "../components"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Pagination from "../components/Pagination"
import BlogCategories from "../components/BlogCategories"
import BlogArticles from "../components/BlogArticles"
import TeamSmiles from "../components/TeamSmiles"
import Subscribe from "../components/Subscribe"

const BlogPage = ({ data, pageContext }) => {
  const SEOData = data.SEOData.SEO

  return (
    <Layout>
      <Seo title={SEOData.title} description={SEOData.description} />
      <IntroSection title={data.PageData.title} />
      <BlogCategories />
      <BlogArticles articles={data.BlogArticles.nodes} />
      <Pagination data={pageContext} rootPath="/blog" />
      {/* nice spacer below */}
      <div className="pt-12 md:pt-14 lg:pt-0"></div>
      <TeamSmiles />
      <SubscribeSection />
    </Layout>
  )
}

const IntroSection = ({ title }) => {
  return (
    <section className="c-container-full lg:space-x-20 xl:space-x-40 pt-24 lg:pt-40 lg:flex justify-between">
      <FadeInTop>
        <h1 className="font-headings text-5xl lg:text-6xl xl:text-8xl leading-tight lg:leading-tight xl:leading-tight mb-4">
          {title}
        </h1>
      </FadeInTop>
      <FadeInTop delay={0.3}>
        <p className="flex-shrink-0 text-[#999] text-lg lg:text-xl leading-normal lg:leading-normal xl:pr-20">
          <a href="#subscribe" className="underline text-white">
            Subscribe
          </a>{" "}
          for direct insight to your mail.
          <br /> <span className="text-white">We won't spam your mail box</span>
        </p>
      </FadeInTop>
    </section>
  )
}

const SubscribeSection = () => {
  return (
    <div className="bg-white pt-20 lg:pt-28 xl:pt-40">
      <Subscribe lightVariant={true} />
    </div>
  )
}

export default BlogPage

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    BlogArticles: allSanityPost(
      skip: $skip
      limit: $limit
      sort: { fields: publishedAt, order: DESC }
      filter: { publishedAt: { ne: null } }
    ) {
      nodes {
        title
        category {
          title
          slug {
            current
          }
        }
        slug {
          current
        }
        mainImage {
          asset {
            gatsbyImageData
          }
        }
        publishedAt(formatString: "D MMMM YYYY")
      }
    }

    SEOData: sanityPageBlog {
      SEO {
        title: seoTitle
        description: seoDescription
      }
    }

    PageData: sanityPageBlog {
      title
    }
  }
`
